var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12.5C21.5 12.6989 21.421 12.8897 21.2803 13.0303C21.1397 13.171 20.9489 13.25 20.75 13.25H13.25V20.75C13.25 20.9489 13.171 21.1397 13.0303 21.2803C12.8897 21.421 12.6989 21.5 12.5 21.5C12.3011 21.5 12.1103 21.421 11.9697 21.2803C11.829 21.1397 11.75 20.9489 11.75 20.75V13.25H4.25C4.05109 13.25 3.86032 13.171 3.71967 13.0303C3.57902 12.8897 3.5 12.6989 3.5 12.5C3.5 12.3011 3.57902 12.1103 3.71967 11.9697C3.86032 11.829 4.05109 11.75 4.25 11.75H11.75V4.25C11.75 4.05109 11.829 3.86032 11.9697 3.71967C12.1103 3.57902 12.3011 3.5 12.5 3.5C12.6989 3.5 12.8897 3.57902 13.0303 3.71967C13.171 3.86032 13.25 4.05109 13.25 4.25V11.75H20.75C20.9489 11.75 21.1397 11.829 21.2803 11.9697C21.421 12.1103 21.5 12.3011 21.5 12.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/PlusIcon.8afabefa034e6896234671918e06f014.svg";
export { ForwardRef as ReactComponent };